import { t } from "i18next";
import * as yup from "yup";

export const schoolRegisterValidationSchema1 = () => {
  return yup.object().shape({
    facilityFullName: yup
      .string()
      .min(3, " ")
      .max(20, " ")
      .required(t("form.error.facilityFullName.required")!),
    email: yup
      .string()
      .min(3, " ")
      .max(50, " ")
      .email(t("form.error.email.emailForm")!)
      .required(t("form.error.email.required")!),
    userName: yup
      .string()
      .matches(/^\S+$/, t("form.error.userName.space")!)
      .matches(/^[^0-9].*$/, " "!)
      .matches(/^[A-Za-z0-9_-]*[-_.][A-Za-z0-9_-]*$/, " "!)
      .min(3, " ")
      .max(20, " ")
      .required(t("form.error.userName.required")!),
    password: yup
      .string()
      .min(8, " ")
      .max(20, " ")
      .required(t("form.error.password.required")!),
    confirmPassword: yup
      .string()
      .oneOf(
        [yup.ref("password"), ""],
        t("form.error.confirmPassword.matching")!
      )
      .required(t("form.error.confirmPassword.required")!),
  });
};

export const schoolRegisterValidationSchema2 = () => {
  return yup.object().shape({
    // country: yup.object().required(t("form.error.country.required")!),
    // city: yup.object().required(t("form.error.city.required")!),
    // district: yup.object().required(t("form.error.district.required")!),
    contactPersonName: yup
      .string()
      .min(3, " ")
      .max(25, " ")
      .required(t("form.error.contactPersonName.required")!),
    phoneNumber: yup
      .string()
      .min(9, " ")
      .max(9, " ")
      .required(t("form.error.phoneNumber.required")!),
    ministerialNumber: yup
      .string()
      .min(6, " ")
      .max(15, " ")
      .required(t("form.error.ministerialNumber.required")!),
    postBox: yup
      .string()
      .min(5, " ")
      .max(15, " ")
      .required(t("form.error.postBox.required")!),
    zipCode: yup
      .string()
      .min(5, " ")
      .max(15, " ")
      .required(t("form.error.zipCode.required")!),
  });
};
